import { AsyncPipe } from '@angular/common';
import { Component, Input, ViewEncapsulation, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectCompany } from '@shared/store/company/company.selectors';
import { AppState } from '../../models/app-state.model';

@Component({
  selector: 'cp-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [AsyncPipe],
})
export class FooterComponent {
  @Input() companyLogo: string;

  private readonly globalStore = inject(Store<AppState>);

  protected readonly company$ = this.globalStore.select(selectCompany);
}
